module.exports = __webpack_public_path__ + "img/PCLightMode.af0d9403.png";